import { services_data_methods } from "./services_data_helper";
import { services_catalogue_methods } from "./services_catalogue_helper";
import { services_delete_methods } from "./services_delete_helper";

export const services_helpers = {
    ...services_data_methods,
    ...services_catalogue_methods,
    ...services_delete_methods,
};
